import axiosClient from "./axiosClient";

export const saveTask = async ({ uid, projectId, task }) => {
  const url = `/projects/${projectId}/tasks`;

  const response = await axiosClient.post(url, {
    uid,
    task,
  });

  return response.data;
};

export const getTasksByProject = async ({ uid, projectId }) => {
  const url = `/projects/${projectId}/tasks`;

  const response = await axiosClient.get(url, {
    params: { uid },
  });

  return response.data;
};

export const updateTask = async ({ uid, projectId, taskId, updates }) => {
  const url = `/projects/${projectId}/tasks/${taskId}`;

  const response = await axiosClient.put(url, {
    uid,
    updates,
  });

  return response.data;
};

export const updateTaskTag = async ({ uid, projectId, taskId, tag }) => {
  const url = `/projects/${projectId}/tasks/${taskId}/tag`;

  const response = await axiosClient.patch(url, {
    uid,
    tag,
  });

  return response.data;
};

export const deleteTask = async ({ uid, projectId, taskId }) => {
  if (!uid || !projectId || !taskId) {
    throw new Error("deleteTask: uid, projectId, and taskId are required");
  }

  const url = `/projects/${projectId}/tasks/${taskId}`;

  const response = await axiosClient.delete(url, {
    data: { uid }, // ✅ CRITICAL
  });

  return response.data;
};
